export const tooltip = {
  writeOffTooltipText:
    'You can manually change the status of an invoice to “write-off” when you have performed legal services for a client for which you have not been/will not be compensated for despite all attempts to resolve with the client. Marking an invoice as “write-off” is not visible to your client. If the client does pay the invoice, you will need to manually change the status to “paid”.',
  createPaymentTooltipText: 'Record an offline payment',
  recordPayment:
    'You may record failed payments and or charges as a negative number (for example -$500) with a description for the adjustment',
}
